import React from 'react';
import Linklist from '../platformui/Linklist';
export default (props) => (
  <Linklist {...props} Modifiers={{ 'c-linklist--block': true }} />
);